import React from 'react'
import { GithubIcon, LiveIcon } from '../utils/Icons'
import Title from './Title'

const projects = [
  {
    name: 'Zwitter',
    date: ' (01/2021 - 04/2021)',
    video_src:
      'https://res.cloudinary.com/dhnbwvk2m/video/upload/q_auto,vc_vp9/v1689867494/resume/580dd406-7e89-497a-9e89-406dd8a6ae4d_bghpl4.webm',
    desc: `Development of Zwitter enabled me to gain vast knowledge on full stack development. Application of state management, process management (CPU utilisation), web sockets, database indexing & delivery optimization helped to increase the performance of the web app from 63% to 89%. Features includes likes, retweets, replies, text links, hashtags, pinning, bookmarks, follow, unfollow, realtime notifications, realtime messaging, group messaging, newsfeed, searching, upload profile and cover photos, edit bio, authentication, authorization, color change and theme.`,
    techs: `Node.js, React.js, MongoDB, Cloudinary, Socket.io, PWA, Material-UI, Digitalocean
    (backend hosted), Netlify (frontend hosted)`,
    live_demo: `https://zwitter-live.netlify.app`,
    credentials: {
      username: 'demo_99',
      password: 'demo_999',
    },
    source_code: `https://github.com/Premkumar1499/zwitter`,
  },
  {
    name: 'Yaazh Admin and CMS',
    date: ` (02/2023 - 05/2023)`,
    video_src:
      'https://res.cloudinary.com/dhnbwvk2m/video/upload/q_auto,vc_vp9/v1689866863/resume/689cf0b1-f797-4594-8a56-6392b8e6031e_ka3oup.webm',
    desc: `Developed a robust admin and CMS platform with advanced authentication, including refresh token
    rotation for enhanced security. The platform allows seamless addition of new admins with role-based
    access controls. For the CMS part, I implemented a versatile data table and various features like products, categories, nested categories, email templates, blogs, coupons, discounts, and banners. Notably, all components were designed with reusability in mind, making them adaptable for future projects, thus
    saving time and resources`,
    techs: `React.js, RTK Query, Formik, Yup, Node.js, Express, PostgreSQL, Cloudinary, Material- UI Data Grid. `,
    live_demo: `https://yaazhadmin-test.netlify.app/`,
    frontend_source_code: `https://github.com/prem-14/Yaazh-admin`,
    backend_source_code: `https://github.com/prem-14/Yaazh-api`,
  },
  {
    name: 'YaazhProducts ecommerce',
    date: ` (05/2023 - 07/2023)`,
    video_src:
      'https://res.cloudinary.com/dhnbwvk2m/video/upload/q_auto,vc_vp9/v1689866976/resume/a6e902c8-df24-4397-a904-a18342609f8e_s063ti.webm',
    desc: `Developed a frontend application for an YaazhProducts ecommerce platform, with reusable components and modern technologies and integrating a robust admin and CMS system. The application incorporated
    cart functionality, Razorpay payment integration, and Shiprocket shipping services, database triggers etc.`,
    techs: `Next.js, RTK Query, Node.js, Express, PostgreSQL, Material-UI, Docker`,
    nav_path: 'yaazh_front',
  },
]

const Project = () => {
  return (
    <div id='projects'>
      <Title title='Personal Projects' />
      {projects.map((project) => (
        <div key={project.name} id={project.nav_path ? project.nav_path : ''}>
          <p className='project_name'>
            {project.name} <span>{project.date}</span>
          </p>
          <div className='project small-flex-wrap'>
            <video
              controls
              autoPlay='autoplay'
              muted
              loop
              onClick={() => {
                console.log('clicked')
              }}
            >
              <source src={project.video_src} type='video/webm' />
              Sorry, your browser doesn't support videos.
            </video>
            <div className='project_desc'>
              <div>{project.desc}</div>
              <div className='project_techs'>
                <strong>Techs used:</strong> {project.techs}
              </div>
              <div className='project_demo flex mt-15'>
                {project.live_demo && (
                  <a href={project.live_demo} target='blank'>
                    <LiveIcon className='svg-25' />
                    <span>Live demo</span>
                  </a>
                )}
                {project.source_code && (
                  <a href={project.source_code} target='blank'>
                    <GithubIcon className='svg-25' />
                    <span>Source code</span>
                  </a>
                )}

                {project.frontend_source_code && (
                  <a href={project.frontend_source_code} target='blank'>
                    <GithubIcon className='svg-25' />
                    <span>frontend Source code</span>
                  </a>
                )}

                {project.backend_source_code && (
                  <a href={project.backend_source_code} target='blank'>
                    <GithubIcon className='svg-25' />
                    <span>backend Source code</span>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default Project
